import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CpfHelper } from '../helpers/cpf.helper';

@Directive({
  selector: '[cpfMask]',
})
export class CpfMaskDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;

    if (!input) return;

    const formatted = CpfHelper.format(input.value);

    this.ngControl.control?.setValue(formatted, { emitEvent: false });
  }
}
